/**
 * The New exploration page's draft: everything chosen before the exploration
 * exists. The page pre-fills it from the most recent exploration
 * (helper/explorationSetupDefaults.js) and the Start button creates the
 * exploration from it (ExplorationStartSection.js).
 */
export const EMPTY_EXPLORATION_DRAFT = {
    // Only the tag is typed; the exploration ID (Material-Alloy-LaserID-Tag-Date)
    // is composed from it, the substrate, the laser and the start date
    // (helper/explorationName.js).
    tag: "",
    description: "",
    objectiveId: "",
    objectiveName: "",
    laserId: "",
    laserName: "",
    // The laser's design-space config name (from the LaserDevice row).
    laserConfigName: "",
    materialId: "",
    materialName: "",
    cameraCalibrationId: "",
    // Where the substrate sits under the laser (mm along the laser axes).
    plateOffset: { x: 0, y: 0 },
    markHeader: true,
};
